export const ACCOUNT_TYPES = [
    'cash',
    'bank',
    'e_wallet',
    'broker_cash',
    'broker_investment',
    'savings',
    'other_asset',
    'liability',
    'credit_card',
];
/**
 * A card and a plain loan are both liabilities in the ledger, but they are NOT the same
 * thing in the cash-flow report: settling a card statement is not debt reduction, the
 * expense was already counted when the card was swiped (G1/DBD-018).
 */
export const LIABILITY_ACCOUNT_TYPES = ['liability', 'credit_card'];
export const USAGE_SCOPES = ['personal', 'household', 'mixed'];
export const CAPTURE_MODES = [
    'manual',
    'monthly_summary',
    'statement_import',
    'api_sync',
    'mixed',
];
export const INCOME_SOURCE_TYPES = [
    'salary',
    'bonus',
    'creator',
    'freelance',
    'business',
    'crypto',
    'investment',
    'interest',
    'dividend',
    'rental',
    'gift',
    'other',
];
/**
 * How much of this income can be planned on. The baseline of `safe_to_invest` is built on
 * stable flows only (B10), so this is a financial input, not a label.
 */
export const STABILITY_CLASSES = ['stable', 'semi_stable', 'variable', 'one_off'];
export function isAccountType(value) {
    return typeof value === 'string' && ACCOUNT_TYPES.includes(value);
}
export function isUsageScope(value) {
    return typeof value === 'string' && USAGE_SCOPES.includes(value);
}
export function isCaptureMode(value) {
    return typeof value === 'string' && CAPTURE_MODES.includes(value);
}
export function isIncomeSourceType(value) {
    return typeof value === 'string' && INCOME_SOURCE_TYPES.includes(value);
}
export function isStabilityClass(value) {
    return typeof value === 'string' && STABILITY_CLASSES.includes(value);
}
export function isLiabilityAccountType(accountType) {
    return LIABILITY_ACCOUNT_TYPES.includes(accountType);
}
/** Mirrors `app.sync_ledger_account_for_account`: everything else is an asset. */
export function ledgerKindOfAccountType(accountType) {
    return isLiabilityAccountType(accountType) ? 'liability' : 'asset';
}
const NAME_MAX_LENGTH = 80;
function validateName(name, issues) {
    const trimmed = name.trim();
    if (trimmed === '') {
        issues.push({ field: 'name', code: 'REQUIRED' });
    }
    else if (trimmed.length > NAME_MAX_LENGTH) {
        issues.push({ field: 'name', code: 'TOO_LONG' });
    }
}
function result(issues) {
    return issues.length === 0 ? { ok: true } : { ok: false, issues };
}
export function validateAccountInput(input) {
    const issues = [];
    validateName(input.name, issues);
    if (!isAccountType(input.accountType)) {
        issues.push({ field: 'accountType', code: 'INVALID_VALUE' });
    }
    if (!isUsageScope(input.usageScope)) {
        issues.push({ field: 'usageScope', code: 'INVALID_VALUE' });
    }
    if (!isCaptureMode(input.captureMode)) {
        issues.push({ field: 'captureMode', code: 'INVALID_VALUE' });
    }
    const opening = input.openingBalance;
    if (opening !== undefined) {
        if (!Number.isSafeInteger(opening)) {
            // VND has no minor unit, so a non-integer amount is a bug, not a rounding question
            // (DBD-014, react-pwa-engineering skill 6.1).
            issues.push({ field: 'openingBalance', code: 'NOT_INTEGER' });
        }
        else if (opening < 0) {
            issues.push({ field: 'openingBalance', code: 'NEGATIVE_AMOUNT' });
        }
    }
    return result(issues);
}
export function validateIncomeSourceInput(input) {
    const issues = [];
    validateName(input.name, issues);
    if (!isIncomeSourceType(input.sourceType)) {
        issues.push({ field: 'sourceType', code: 'INVALID_VALUE' });
    }
    if (!isStabilityClass(input.stabilityClass)) {
        issues.push({ field: 'stabilityClass', code: 'INVALID_VALUE' });
    }
    return result(issues);
}
//# sourceMappingURL=account.js.map